import { defineComponent } from 'bitecs';

const Protagonist = defineComponent();

export { Protagonist };
